import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, map, Observable, of, switchMap } from 'rxjs';
import { TranslateLoader, Translation } from '@ngx-translate/core';

export function HttpLoaderFactory(): AsyncTranslateLoader {
  return new AsyncTranslateLoader();
}

/**
 * Index written by the `kros-merge-translations` executor: two letter language code -> merged file name.
 *
 * @example { "sk": "merged-translations.a1b2c3d4.sk-SK.json", "en": "merged-translations.e5f6a7b8.en-GB.json" }
 */
type MergedTranslationsIndex = Record<string, string>;

class AsyncTranslateLoader implements TranslateLoader {
  private readonly assetsPath = 'assets/i18n/';
  private readonly indexFilePath = `assets/i18n/merged-translations.json?cacheBusting=${new Date().getTime()}`;
  private filePaths: string[] = [];
  private filePathsLoaded = false;

  private readonly http = inject(HttpClient);

  private loadFilePaths(): Observable<string[]> {
    return this.http.get<MergedTranslationsIndex>(this.indexFilePath).pipe(
      map((index) => {
        this.filePaths = Object.values(index).map((fileName) => `${this.assetsPath}${fileName}`);
        this.filePathsLoaded = true;
        return this.filePaths;
      })
    );
  }

  getTranslation(lang: string): Observable<Translation> {
    if (!this.filePathsLoaded) {
      return this.loadFilePaths().pipe(switchMap(() => this.getTranslation(lang)));
    } else {
      const filePath = this.filePaths.find((file) => file.includes(lang));
      return this.http.get<Translation>(filePath || '').pipe(catchError(() => of({})));
    }
  }
}
